import { render, staticRenderFns } from "./DataSingleRenderOLD.vue?vue&type=template&id=0ec4ba1e&"
import script from "./DataSingleRenderOLD.vue?vue&type=script&lang=js&"
export * from "./DataSingleRenderOLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports